/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  all: {
    id: "b2b.zadosti.all",
    defaultMessage: "All"
  }
});

export default () => useMessages(MESSAGES);
